import axios from '../Backend';



export const getDropDownList = async (dropdownCategory, name) => {
    try {
        const res = await axios.get(`/api/v2/dropdown?category=${dropdownCategory}${name ? `&name=${name}` : ''}`);
        const resData = res.data
        if (resData.status !== 'success') throw new Error('Unknown Error')
        let dropdownObj = resData.data?.data
        // if (!dropdownObj || dropdownObj.length === 0) dropdownObj = [defaultServiceTypeDropDownObj]
        return dropdownObj
    } catch (e) {
        if (e.response) console.log(`getDropDownList :: Response Error=${JSON.stringify(e.response.data)}`)
        else console.log(`getDropDownList :: Error=${JSON.stringify(e.message)}`)
        throw e
    }
}

export const insertDropDownList = async (data) => {
    try {
        //Delete Create obj
        data.dropDownItems = data.dropDownItems.filter(item => item.key !== 'Create')



        const res = await axios.post(`/api/v2/dropdown`, data);
        const resData = res.data
        if (resData.status !== 'success') throw new Error('Unknown Error')
        return resData.data?.data
    } catch (e) {
        if (e.response) console.log(`insertDropDownList :: Response Error=${JSON.stringify(e.response.data)}`)
        else console.log(`insertDropDownList :: Error=${JSON.stringify(e.message)}`)
        throw e
    }
}

export const updateDropDownList = async (id, data) => {
    try {

        //Delete Create obj
        const res = await axios.patch(`/api/v2/dropdown/${id}`, data);
        const resData = res.data
        if (resData.status !== 'success') throw new Error('Unknown Error')
        return resData.data?.data?.[0]
    } catch (e) {
        if (e.response) console.log(`insertDropDownList :: Response Error=${JSON.stringify(e.response.data)}`)
        else console.log(`insertDropDownList :: Error=${JSON.stringify(e.message)}`)
        throw e
    }
}

export const updateDropDownItem = async (dropDownObj, dropDownItem) => {
    if (dropDownItem.key === 'Create' || !dropDownItem.key) return

    let updatedDropDown
    const serviceTypeDropDownObjToSave = JSON.parse(JSON.stringify(dropDownObj))
    

    //Delete Create obj
    const createItemIndex = serviceTypeDropDownObjToSave.dropDownItems.findIndex((item) => item.key === 'Create' || !item.key)
    if (createItemIndex > -1) {
        serviceTypeDropDownObjToSave.dropDownItems.splice(createItemIndex, 1)
    }

    //Update or Insert Data
    if (serviceTypeDropDownObjToSave._id) {//Update dropDownObj
        if (dropDownItem._id) {//Update dropDownItemObj
            const toUpdateDropDownItemIndex = serviceTypeDropDownObjToSave.dropDownItems.findIndex((item) => item._id === dropDownItem._id)
            if (toUpdateDropDownItemIndex < 0) {
                const dropDownItemCopy = JSON.parse(JSON.stringify(dropDownItem))
                dropDownItemCopy._id = undefined
                serviceTypeDropDownObjToSave.dropDownItems.push(dropDownItemCopy)
            }
            else {
                serviceTypeDropDownObjToSave.dropDownItems.splice(toUpdateDropDownItemIndex, 1, dropDownItem)
            }
        }
        else {//if there is no Id its mean dropDownItemObj still not inserted to DB 
            serviceTypeDropDownObjToSave.dropDownItems.push(dropDownItem)
        }
        updatedDropDown = await updateDropDownList(serviceTypeDropDownObjToSave._id, serviceTypeDropDownObjToSave)
    }
    else {//if there is no Id its mean dropDownObj still not inserted to DB 
        serviceTypeDropDownObjToSave.dropDownItems.push(dropDownItem)
        updatedDropDown = await insertDropDownList(serviceTypeDropDownObjToSave)
    }

    return updatedDropDown
}

export const deleteDropDownItem = async (dropDownObj, dropDownItem) => {
    if (!dropDownObj._id || !dropDownItem._id) return

    const serviceTypeDropDownObjUpdate = JSON.parse(JSON.stringify(dropDownObj))

    //Delete Create obj
    const createItemIndex = serviceTypeDropDownObjUpdate.dropDownItems.findIndex((item) => item.key === 'Create' || !item.key)
    if (createItemIndex > -1) {
        serviceTypeDropDownObjUpdate.dropDownItems.splice(createItemIndex, 1)
    }

    const toUpdateDropDownItemIndex = serviceTypeDropDownObjUpdate.dropDownItems.findIndex((item) => item._id === dropDownItem._id)
    if (toUpdateDropDownItemIndex < 0) return
    serviceTypeDropDownObjUpdate.dropDownItems.splice(toUpdateDropDownItemIndex, 1)
    return await updateDropDownList(serviceTypeDropDownObjUpdate._id, serviceTypeDropDownObjUpdate)
}

export const deleteDropDown = async (id) => {
    try {
        const res = await axios.delete(`/api/v2/dropdown/${id}`);
        const resStatus = res.status
        if (resStatus !== 204) throw new Error('Unknown Error')
        return true
    } catch (e) {
        if (e.response) console.log(`insertDropDownList :: Response Error=${JSON.stringify(e.response.data)}`)
        else console.log(`insertDropDownList :: Error=${JSON.stringify(e.message)}`)
        throw e
    }
}